import {useGlobalFulfillmentDetail} from '@/components/global/providers/GlobalFulfillmentDetailProvider';
import {useStoreNextRouter} from '@/components/global/providers/StoreNextRouter';
import {type FulfillmentDetailAddressInput} from '@/graphql/types';
import useIdentity from '@/hooks/useIdentity';
import {geocodedAddressResultToFulfillmentDetailAddressInput} from '@/utils/geocodedAddressResult';

// The address the bar shows and commits when the page has no detail. A menu page's own fallback is
// the caterer's city, so prefer the user's recommended address there when it has a street. Search
// pages already use the recommended address as their fallback.
export const useEventBarFallbackAddress = (): FulfillmentDetailAddressInput | undefined => {
  const {fallbackAddress} = useGlobalFulfillmentDetail();
  const {isOnMenuPage} = useStoreNextRouter();
  const {data: identityData} = useIdentity();
  const recommended = identityData?.identity?.recommendedDefaultAddress;
  if (isOnMenuPage && recommended?.street)
    return geocodedAddressResultToFulfillmentDetailAddressInput(recommended);
  return fallbackAddress;
};
